import { render, staticRenderFns } from "./UserResult.vue?vue&type=template&id=6cd9e59c&"
import script from "./UserResult.vue?vue&type=script&lang=js&"
export * from "./UserResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/users/UserResult.vue
// module id = 1433
// module chunks = 0